import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "assets/theme";
import Rotas from "rotas";



const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Rotas />
    </ThemeProvider>
  );
}

export default App;
